import { useCallback } from "react";

export const useWhatsApp = () => {
  // 1. Função auxiliar para limpar e formatar o telefone
  const formatPhone = (phone) => {
    if (!phone) return "";

    // Remove tudo que não for número
    let cleanPhone = String(phone).replace(/\D/g, "");

    // Se tiver 10 ou 11 dígitos (Ex: 11999998888), adiciona o DDI 55
    if (cleanPhone.length >= 10 && cleanPhone.length <= 11) {
      cleanPhone = `55${cleanPhone}`;
    }

    // Se já tiver 12 ou 13 dígitos (começando com 55), mantém.
    // Segurança extra: garantir que começa com 55
    if (!cleanPhone.startsWith("55") && cleanPhone.length > 11) {
      cleanPhone = `55${cleanPhone}`;
    }

    return cleanPhone;
  };

  // 2. Dicionário de Mensagens baseadas no Status
  const getMessage = (customerName, orderNumber, status) => {
    const firstName = customerName ? customerName.split(" ")[0] : "Cliente";
    const base = `Olá ${firstName}, aqui é da Sempre Joias!`;

    // Normalize o status para garantir match (caso venha minúsculo)
    const normalizedStatus = String(status).toUpperCase();

    switch (normalizedStatus) {
      case "SOLICITACAO":
        return `${base} Recebemos seu pedido #${orderNumber} e ele já está na fila de análise.`;
      case "PRODUCAO":
        return `${base} Boas notícias! O item do seu pedido #${orderNumber} acabou de entrar em produção.`;
      case "ENVIADO":
      case "EXPEDICAO":
        return `${base} Seu pedido #${orderNumber} foi enviado! Logo logo chega até você.`;
      case "ENTREGUE":
        return `${base} Vimos que seu pedido #${orderNumber} foi entregue. Esperamos que ame!`;
      case "FALTA":
        return `${base} Tivemos um imprevisto com o pedido #${orderNumber}. Nossa equipe entrará em contato em breve.`;
      default:
        // Mensagem Genérica
        return `${base} Passando para informar que houve uma atualização no status do seu pedido #${orderNumber} para: ${status}.`;
    }
  };

  // 3. A função principal que será chamada pelo botão
  const sendWhatsAppMessage = useCallback(
    (customerData, orderNumber, currentStatus) => {
      // Tenta pegar o celular, se não tiver, tenta o telefone fixo/principal
      const rawPhone =
        customerData.phone ||
        customerData.cellphone ||
        customerData.telefones?.celular;

      if (!rawPhone) {
        alert("Cliente sem telefone cadastrado!");
        return;
      }

      const phone = formatPhone(rawPhone);
      const message = getMessage(customerData.name, orderNumber, currentStatus);

      // Codifica a mensagem para URL (transforma espaços em %20, etc)
      const encodedMessage = encodeURIComponent(message);

      // Abre a API do WhatsApp
      const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
      window.open(url, "_blank", "noopener,noreferrer");
    },
    []
  );

  return { sendWhatsAppMessage };
};
